const MenuData = [
    {
        title: 'Home',
        path: '/home',
        submenu:
            [
                {
                    subtitle: 'About Us',
                    path: '/home/about'
                },
                {
                    subtitle: 'Contact Us',
                    path: '/home/contact'
                },

            ]
    },
    {
        title: 'Measures',
        path: '/measures',
        submenu:
            [
                {
                    subtitle: 'QI Resources',
                    path: '/measures/qi_resources'
                },
                {
                    subtitle: 'PQI Resources',
                    path: '/measures/pqi_resources'
                },
                {
                    subtitle: 'IQI Resources',
                    path: '/measures/iqi_resources'
                },
                {
                    subtitle: 'PSI Resources',
                    path: '/measures/psi_resources'
                },
                {
                    subtitle: 'PDI Resources',
                    path: '/measures/pdi_resources'
                },
                {
                    subtitle: 'All Measures',
                    path: '/measures/all_measures'
                }

            ]
    },
    {
        title: 'Software',
        path: '/software',
        submenu:
            [
                {
                    subtitle: 'QI Software',
                    path: '/software/qi'
                },
                {
                    subtitle: 'SAS QI',
                    path: '/software/sas_qi'
                },
                {
                    subtitle: 'WinQI',
                    path: '/software/win_qi'
                },


            ]
    },

    {
        title: 'News',
        path: '/news',
        submenu: []
    },
    {
        title: 'Resources',
        path: '/resources',
        submenu:
            [
                {
                    subtitle: 'Webinars',
                    path: '/resources/webinars'
                },
                {
                    subtitle: 'Case Studies',
                    path: '/resources/case_studies'
                },
                {
                    subtitle: 'Presentations',
                    path: '/resources/presentations'
                },
                {
                    subtitle: 'Publications',
                    path: '/resources/publications'
                },
                {
                    subtitle: 'Toolkits',
                    path: '/resources/toolkits'
                },
            ]
    },
    {
        title: 'FAQs',
        path: '/faqs',
        submenu: []
    },
    {
        title: 'Archives',
        path: '/archive',
        submenu:
            [
                {
                    subtitle: 'QI Modules',
                    path: '/archive/qi_modules'
                },
                {
                    subtitle: 'News',
                    path: '/archive/news'
                },
                {
                    subtitle: 'Software',
                    path: '/archive/software'
                },
                {
                    subtitle: 'Resources',
                    path: '/archive/resources'
                },
            ]
    },

]
export default MenuData;